export const interiorView02ImageOptions = {
  angle: 'InteriorView02',
  staticOptions: {
    Fabric: 1,
    FabricOwners: 1
  },
  mattes: [
    {
      option: 'Fabric',
      dependency: 'Layout'
    },
    {
      option: 'FabricOwners',
      dependency: 'Layout'
    }
  ],
  overlays: []
}



// WEBPACK FOOTER //
// ./src/Xr41/views/InteriorView02.js